/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunnelProductOwnerDto } from './FunnelProductOwnerDto';
import {
    FunnelProductOwnerDtoFromJSON,
    FunnelProductOwnerDtoFromJSONTyped,
    FunnelProductOwnerDtoToJSON,
    FunnelProductOwnerDtoToJSONTyped,
} from './FunnelProductOwnerDto';
import type { TargetedSubscriberEnum } from './TargetedSubscriberEnum';
import {
    TargetedSubscriberEnumFromJSON,
    TargetedSubscriberEnumFromJSONTyped,
    TargetedSubscriberEnumToJSON,
    TargetedSubscriberEnumToJSONTyped,
} from './TargetedSubscriberEnum';

/**
 * 
 * @export
 * @interface FunnelProductDto
 */
export interface FunnelProductDto {
    /**
     * Unique identifier of the product
     * @type {string}
     * @memberof FunnelProductDto
     */
    id: string;
    /**
     * Code of the product
     * @type {string}
     * @memberof FunnelProductDto
     */
    code: string;
    /**
     * Label of the product
     * @type {string}
     * @memberof FunnelProductDto
     */
    label: string;
    /**
     * 
     * @type {FunnelProductOwnerDto}
     * @memberof FunnelProductDto
     */
    owner: FunnelProductOwnerDto;
    /**
     * URL of the product logo
     * @type {string}
     * @memberof FunnelProductDto
     */
    logoURL?: string;
    /**
     * Fixed-guarantees formula, subscribed as is with all its guarantees, no score
     * @type {boolean}
     * @memberof FunnelProductDto
     */
    isFixedFormula?: boolean;
    /**
     * 
     * @type {TargetedSubscriberEnum}
     * @memberof FunnelProductDto
     */
    targetedSubscriber?: TargetedSubscriberEnum;
}



/**
 * Check if a given object implements the FunnelProductDto interface.
 */
export function instanceOfFunnelProductDto(value: object): value is FunnelProductDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    return true;
}

export function FunnelProductDtoFromJSON(json: any): FunnelProductDto {
    return FunnelProductDtoFromJSONTyped(json, false);
}

export function FunnelProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'owner': FunnelProductOwnerDtoFromJSON(json['owner']),
        'logoURL': json['logoURL'] == null ? undefined : json['logoURL'],
        'isFixedFormula': json['isFixedFormula'] == null ? undefined : json['isFixedFormula'],
        'targetedSubscriber': json['targetedSubscriber'] == null ? undefined : TargetedSubscriberEnumFromJSON(json['targetedSubscriber']),
    };
}

export function FunnelProductDtoToJSON(json: any): FunnelProductDto {
    return FunnelProductDtoToJSONTyped(json, false);
}

export function FunnelProductDtoToJSONTyped(value?: FunnelProductDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'owner': FunnelProductOwnerDtoToJSON(value['owner']),
        'logoURL': value['logoURL'],
        'isFixedFormula': value['isFixedFormula'],
        'targetedSubscriber': TargetedSubscriberEnumToJSON(value['targetedSubscriber']),
    };
}

